import { mode } from '@chakra-ui/theme-tools';
import { Dict } from '@chakra-ui/utils';

export const SwitchTheme = {
	variants: {
		primary: (props: Dict<unknown>) => ({
			track: {
				padding: '1px',
				bg: mode('#B8B9BA', 'gray.500')(props),
				borderWidth: '1px',
				_focus: {
					boxShadow: 'none'
				},
				_checked: {
					bg: 'darkCoral',
					borderColor: mode('brand.400', 'orange.300')(props)
				}
			},
			thumb: {
				height: '100%',
				bg: mode('white', 'gray.600')(props),
				_checked: {
					bg: 'white'
				}
			},
			defaultProps: {
			
			}
		})
	},
	defaultProps: {
	
	},
};

